<div class="dashboard-container">
  <div class="dashboard-content">
    <div class="stats-grid">
      <!-- Total Users Metric -->
      <div class="stat-card">
        <div class="stat-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>Total Users</h3>
          <p class="stat-number" *ngIf="!isLoadingStats && dashboardStats">
            {{ dashboardStats.totalUsers }}
          </p>
          <p class="stat-loading" *ngIf="isLoadingStats">Loading...</p>
          <p class="stat-error" *ngIf="statsError && !isLoadingStats">Error</p>
        </div>
      </div>

      <!-- Digital Cards Metric -->
      <div class="stat-card">
        <div class="stat-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>Digital Cards</h3>
          <p class="stat-number" *ngIf="!isLoadingStats && dashboardStats">
            {{ dashboardStats.totalCards }}
          </p>
          <p class="stat-sub" *ngIf="!isLoadingStats && dashboardStats">
            {{ dashboardStats.activeCards }} active
          </p>
          <p class="stat-loading" *ngIf="isLoadingStats">Loading...</p>
          <p class="stat-error" *ngIf="statsError && !isLoadingStats">Error</p>
        </div>
      </div>

      <!-- Bookmarks Metric -->
      <div class="stat-card">
        <div class="stat-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>Bookmarks</h3>
          <p class="stat-number" *ngIf="!isLoadingStats && dashboardStats">
            {{ dashboardStats.totalBookmarks }}
          </p>
          <p class="stat-loading" *ngIf="isLoadingStats">Loading...</p>
          <p class="stat-error" *ngIf="statsError && !isLoadingStats">Error</p>
        </div>
      </div>

      <!-- Active Sessions Metric -->
      <div class="stat-card">
        <div class="stat-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>Active Admins</h3>
          <p class="stat-number" *ngIf="!isLoadingStats && dashboardStats">
            {{ dashboardStats.activeAdmins }}
          </p>
          <p class="stat-sub" *ngIf="!isLoadingStats && dashboardStats">
            of {{ dashboardStats.totalAdmins }} total
          </p>
          <p class="stat-loading" *ngIf="isLoadingStats">Loading...</p>
          <p class="stat-error" *ngIf="statsError && !isLoadingStats">Error</p>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div class="error-banner" *ngIf="statsError && !isLoadingStats">
      <p>{{ statsError }}</p>
      <button (click)="loadDashboardStats()" class="retry-btn">Retry</button>
    </div>

    <!-- Enhanced Metrics Section -->
    <div class="enhanced-metrics" *ngIf="!isLoadingStats && dashboardStats">
      <div class="metrics-section">
        <div class="section-header">
          <h2>Card Analytics (Cloud Function Data)</h2>
          <a routerLink="/metrics" class="view-details-btn">
            📊 View Detailed Metrics
          </a>
        </div>
        <div class="metrics-grid">
          <div class="metric-item">
            <span class="metric-label">Cards Created</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.created || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Cards Updated</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.updated || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Cards Deleted</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.deleted || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Total Views</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.totalViews || 0 }}</span>
            <span class="metric-note">Coming Soon</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Total Clicks</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.totalClicks || 0 }}</span>
            <span class="metric-note">Coming Soon</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Total Shares</span>
            <span class="metric-value">{{ dashboardStats.cardMetrics?.totalShares || 0 }}</span>
            <span class="metric-note">Coming Soon</span>
          </div>
        </div>
      </div>

      <div class="metrics-section">
        <div class="section-header">
          <h2>User Activity (Cloud Function Data)</h2>
          <a routerLink="/metrics" class="view-details-btn">
            📈 View Details
          </a>
        </div>
        <div class="metrics-grid">
          <div class="metric-item">
            <span class="metric-label">Users Created</span>
            <span class="metric-value">{{ dashboardStats.userMetrics?.created || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Users Updated</span>
            <span class="metric-value">{{ dashboardStats.userMetrics?.updated || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Users Deleted</span>
            <span class="metric-value">{{ dashboardStats.userMetrics?.deleted || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Active Users</span>
            <span class="metric-value">{{ dashboardStats.userMetrics?.activeUsersToday || 0 }}</span>
          </div>
        </div>
      </div>

      <div class="metrics-section">
        <div class="section-header">
          <h2>Bookmark Activity (Cloud Function Data)</h2>
          <a routerLink="/metrics" class="view-details-btn">
            🔖 View Details
          </a>
        </div>
        <div class="metrics-grid">
          <div class="metric-item">
            <span class="metric-label">Bookmarks Created</span>
            <span class="metric-value">{{ dashboardStats.bookmarkMetrics?.created || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Bookmarks Updated</span>
            <span class="metric-value">{{ dashboardStats.bookmarkMetrics?.updated || 0 }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Bookmarks Deleted</span>
            <span class="metric-value">{{ dashboardStats.bookmarkMetrics?.deleted || 0 }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-sections">
      <section class="dashboard-section">
        <h2>Quick Actions</h2>
        <div class="action-grid">
          <button class="action-btn">
            <span class="action-icon">👤</span>
            <span>Manage Users</span>
          </button>
          <button class="action-btn">
            <span class="action-icon">💳</span>
            <span>Manage Cards</span>
          </button>
          <button class="action-btn">
            <span class="action-icon">📊</span>
            <span>View Analytics</span>
          </button>
          <button class="action-btn">
            <span class="action-icon">⚙️</span>
            <span>Settings</span>
          </button>
        </div>
      </section>
    </div>
  </div>
</div>